import React from 'react';
import Icon from 'components/AppIcon';
import { Flex, Select } from 'antd';

const LoginHeader = () => {
  const groups = [
    { id: '1', name: '🇷🇺 Русский' },
    { id: '2', name: '🇺🇸 English' },
  ];
  const [attachGroupId, setAttachGroupId] = React.useState(groups[0]?.id);
  const [attachingGroup, setAttachingGroup] = React.useState(false);
  
  return (
    <div className=" p-2">
      {/* Logo */}
      <Flex vertical align="center" justify="center">
        <Flex align="center" justify="center" className="w-16 h-16 bg-primary rounded-xl  shadow-lg">
          <Icon name="Shield" size={32} className="text-white" />
        </Flex>

        {/* Brand */}
        <div className="m-2">
          <h1 className="text-3xl font-bold text-text-primary">
            ArtSeaBox
            <Select className="ml-4"
              value={attachGroupId}
              onChange={setAttachGroupId}
              defaultValue={attachGroupId}
              placeholder={groups.length ? "Выберите группу" : "Нет доступных групп"}
              options={groups.map((group) => ({
                label: group.name || group.id,
                value: group.id,
              }))}
            />
          </h1>
          <p className="text-text-secondary">
            Централизованная система аутентификации
          </p>
        </div>
      </Flex>
    </div>
  );
};

export default LoginHeader;